import * as React from 'react'

import { SmartImage, Text } from 'main/ui'
import { Container, ImageContainer, StyledNativeLink } from './BTSBanner.styles'

export default function BSTBanner() {
  return (
    <Container>
      <ImageContainer>
        <SmartImage uuid={'ffa8bd9e-6b8d-49f7-983d-f0b225eef80a'} />
      </ImageContainer>
      <Text>
        We're going Back to School Together! Get 25% off your first month of care |{' '}
        <StyledNativeLink href="https://pages.wonderschool.com/back-to-school-together">
          Details here{' '}
        </StyledNativeLink>
      </Text>
      <ImageContainer>
        <SmartImage uuid={'cb570901-322e-46a1-84d7-a9d5ab938f50'} />
      </ImageContainer>
    </Container>
  )
}
